import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { restoreTutorialSession } from "./tutorials/engine/session";
import "./index.css";

// Before anything renders: a tab that reloaded mid-tutorial must be answered by the
// sample data from its very first request, not by the real API. Immediate otherwise.
restoreTutorialSession().then(() => {
  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
});
